import { gateway } from "../../../../../gateway";

const getAuthHeader = () => {
  const token = sessionStorage.getItem("token");
  return { Authorization: token ?? "" };
};

export const getWorkforceRate = async (uid: string) => {
  const res = await gateway.get(`/jobs/rate/${uid}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};
